import { Injectable } from '@angular/core';
import { AuthService } from '../services';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class PermissionGuard {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const routePermissions: string[] = this.toList(route.data.permissions);
        const routeAnyPermissions: string[] = this.toList(route.data.anyPermissions);

        if (routePermissions.length === 0 && routeAnyPermissions.length === 0) {
            return true;
        }

        const hasAll = routePermissions.length === 0 || this.authService.userHasPermission(routePermissions);
        const hasAny = routeAnyPermissions.length === 0 || this.authService.userHasAnyPermission(routeAnyPermissions);

        if (!hasAll || !hasAny) {
          this.router.navigate(['404']);
          return false;
        }

        return true;
    }

    private toList(value: string | string[]): string[] {
        if (!value) {
            return [];
        }

        return Array.isArray(value) ? value : [value];
    }
}
